<script setup>
import {computed, inject} from 'vue';
import {nl2br} from '@utils/nl2br';
import PayPalButtonComponent from '../../../PayPal/PayPalButtonComponent.vue';
import ButtonComponent from '@buttons/ButtonComponent.vue';
import {showErrorToast, showSuccessToast} from '@utils/Toast';
import {handleErrorResponse} from '@utils/errorHandler';

const props = defineProps({
    course: Object,
    route: String,
    user: Object,
    isAuthenticated: Boolean,
});

// Inject Axios
const axios = inject('axios');

const text = computed(() => {
    return sprintf('%s, to complete the course registration<br />process, please click below to submit<br />your $%d USD enrollment fee.',
        props.user.first_name,
        props.course.price,
    );
});

const coursePrice = computed(() => {
    if(props.course.price === null) {
        return 0;
    }
    return parseFloat(props.course.price);
});

const enrollCourse = async (slug) => {
    const formData = {
        slug: slug,
    };
    try {
        //Send a POST request to the server
        const response = await axios.post(props.route, formData, {
            headers: {
                'X-CSRF-TOKEN': props.csrf // Include CSRF token here
            }
        });
        //Handle response here
        if (response.status === 200) {
            const data = response.data;
            if (data.success === 1) {
                window.location.href = data.redirect;
            } else {
                showErrorToast(data.message);
            }
        } else {
            if (response.message) {
                showErrorToast(response.message);
            }
        }

    } catch (error) {
        showErrorToast(handleErrorResponse(error));
        console.error('Submission error', error);
    }

};

</script>

<template>
    <div>
        <div class="w-10/12 mx-auto">
            <div class="wrap-form form-white mb-6 text-center">
                <div class="text-2xl" v-html="nl2br(text)"></div>
            </div>

            <div class="py-6 lg:py-12 max-w-100 mx-auto">
                <pay-pal-button-component
                    v-if="isAuthenticated"
                    :amount="coursePrice"
                    :slug="course.slug"
                    @enroll-course-paypal="enrollCourse($event)"
                >
                </pay-pal-button-component>
                <button-component
                    v-else
                    title="Login"
                    :btn-class="'btn-primary inline-block w-auto'"
                    :text-size="'!px-6'"
                    href="/login"
                ></button-component>
            </div>

            <div class="bg-primary py-4 px-6 rounded-lg text-left text-white">
                <div class="font-bold">Refund Policy:</div>
                <div>This course is none refundable</div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
